export const login =  function(objIn) {
  console.log(objIn);
  console.log('login!!!!')
  return true;
}

export const addNewRegisterUser = function(objectIn) {
  console.log('registro!!')
  return true;
}

  